import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { AppHeader } from "../../shared/AppHeader";
import { useMe } from "../../shared/hooks/useMe";
import { Spinner } from "../../ui";

const LINKS = [
  ["/account", "Home"],
  ["/account/profile", "Profile"],
  ["/account/security", "Security"],
  ["/account/identities", "Sign-in methods"],
  ["/account/tokens", "API tokens"],
  ["/account/organizations", "Organizations"],
] as const;

export function AccountLayout() {
  const me = useMe();
  const location = useLocation();
  if (me.isLoading) {
    return (
      <main className="p-8">
        <Spinner />
      </main>
    );
  }
  if (!me.data) {
    return (
      <Navigate
        to={`/login?return_to=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }
  return (
    <>
      <AppHeader context={{ kind: "personal" }} />
      <div className="mx-auto flex max-w-5xl flex-col gap-6 p-4 md:flex-row">
        <nav
          className="flex flex-row gap-2 overflow-x-auto rounded-lg border border-slate-200 bg-white p-2 shadow-card md:w-56 md:flex-col"
          aria-label="Account"
        >
          {LINKS.map(([to, label]) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/account"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm ${isActive ? "bg-brand-tint/50 font-medium text-brand-dark" : "text-slate-700 hover:bg-slate-100"}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <section className="flex-1">
          <Outlet context={me.data} />
        </section>
      </div>
    </>
  );
}
